<div class="container">
    <div class="d-flex align-items-center">
        <h1 mat-dialog-title>Edit Organization - Basic Info</h1>
    </div>
    <div class="row my-3">
        <div mat-dialog-content [formGroup]="form">
            <div class="d-flex flex-column">
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Organization's Name <span class="red">*</span></mat-label>
                    <input matInput formControlName="name">
                </mat-form-field>
            </div>
            <div class="d-flex flex-column">
                <mat-form-field appearance="outline">
                    <mat-label>Guest Friendly Name</mat-label>
                    <input matInput formControlName="org_name_to_guest">
                </mat-form-field>
            </div>
            <div class="d-flex flex-column">
                <mat-form-field appearance="outline" hideRequiredMarker>
                    <mat-label>Website <span class="red">*</span></mat-label>
                    <input matInput formControlName="website">
                </mat-form-field>
            </div>
            <div class="d-flex flex-column">
                <mat-form-field appearance="outline">
                    <mat-label>Logo Url</mat-label>
                    <input matInput formControlName="logo_url">
                </mat-form-field>
            </div>
            <div class="d-flex flex-column">
                <h4 class="mb-3">Primary Contact</h4>
                <div class="d-flex justify-content-between">
                    <mat-form-field class="col-5" appearance="outline" hideRequiredMarker>
                        <mat-label>First Name <span class="red">*</span></mat-label>
                        <input matInput formControlName="contact_first_name" hideRequiredMarker>
                    </mat-form-field>
                    <mat-form-field class="col-5" appearance="outline" hideRequiredMarker>
                        <mat-label>Last Name <span class="red">*</span></mat-label>
                        <input matInput formControlName="contact_last_name">
                    </mat-form-field>
                </div>
                <div class="d-flex justify-content-between">
                    <mat-form-field class="col-5" appearance="outline" hideRequiredMarker>
                        <mat-label>Email Address <span class="red">*</span></mat-label>
                        <input matInput formControlName="email_address">
                        <mat-error *ngIf="email_address.invalid">Invalid Email</mat-error>
                    </mat-form-field>
                    <mat-form-field class="col-5" appearance="outline" hideRequiredMarker>
                        <mat-label>Notification Email Address <span class="red">*</span></mat-label>
                        <input matInput formControlName="notification_email" >
                        <mat-error *ngIf="notification_email.invalid">Invalid Email</mat-error>
                    </mat-form-field>
                </div>
                <div class="d-flex justify-content-between">
                    <mat-form-field class="col-5" appearance="outline" hideRequiredMarker>
                        <mat-label>Phone Number <span class="red">*</span></mat-label>
                        <input matInput formControlName="phone_number" (input)="onPhoneNumberChanged($event)">
                            <mat-hint>Ex: (XXX) XXX-XXXX</mat-hint>
                            <mat-error *ngIf="form.controls['phone_number'].invalid">
                                Required
                            </mat-error>
                    </mat-form-field>
                </div>
                <div class="d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Safely Service<span class="required-input">*</span></mat-label>
                        <mat-select formControlName="safely_service_id">
                            <mat-option *ngFor="let service of safelyServices" [value]="service.id">
                                {{ service.name }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('safely_service_id')?.invalid">Required</mat-error>
                    </mat-form-field>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-checkbox class="settings-checkbox" formControlName="send_check_to_safely">
                            Claim Payments via ACH
                        </mat-checkbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-checkbox class="settings-checkbox" formControlName="notify_guest_for_additional_info">
                            Automated Guest Screening Emails
                        </mat-checkbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col d-flex flex-column">
                        <mat-checkbox class="settings-checkbox" formControlName="receive_email_on_guest_verification_complete">
                            Receive Email When Guest Screening Completed
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="my-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-button" mat-dialog-close>
            <mat-icon>cancel</mat-icon>
            Cancel
        </button>
        <button mat-raised-button class="action-button" (click)="onSaveClick()" [disabled]="!form.valid" cdkFocusInitial>
            <mat-icon>check</mat-icon>
            Submit Organization
        </button>
    </div>
    <div class="my-3">
        <mat-action-row class="mt-4 d-flex justify-content-end">
            <div class="d-flex justify-content-end align-items-center text-muted">
                <span class="required-input">*</span>&nbsp;- Required
            </div>
        </mat-action-row>
    </div>
</div>